import React from "react";
import { Col, Container, Form, Row } from "react-bootstrap";
import { Link, useParams } from "react-router-dom";

// img
// import i1 from "@/Assets/images/authBg.png";
import i1 from "../../../../Assets/images/authBg.png";
import { useGetUserDetailsQuery } from "../../../../store/services/userService";
import { useGetRefundDetailsQuery } from "../../../../store/services/refundService";
import moment from "moment";
import {
  macrosBarDynamicPercentage,
  priceCurrency,
} from "../../../../helpers/common";

const RefundDetail = () => {
  // get id from url
  const { id } = useParams();
  const { data: User, error, isLoading } = useGetRefundDetailsQuery(id);

  console.log("user ======>", User);

  if (error) {
    return <div>Something went wrong</div>;
  }

  return (
    <section className="userDetail py-3 position-relative">
      <Container>
        <Row>
          <Col lg="12">
            <div className="d-flex align-items-center gap-10">
              <Link
                to="/refund-transaction"
                className="border d-flex align-items-center p-2 rounded"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="12"
                  height="12"
                  viewBox="0 0 10 16"
                  fill="none"
                >
                  <path
                    d="M8.64707 0.473344C8.55514 0.381188 8.44594 0.308072 8.32572 0.258184C8.20549 0.208296 8.07661 0.182617 7.94644 0.182617C7.81628 0.182617 7.68739 0.208296 7.56717 0.258184C7.44694 0.308072 7.33774 0.381188 7.24582 0.473344L0.667065 7.05209C0.593675 7.12533 0.53545 7.21233 0.495723 7.3081C0.455996 7.40387 0.435547 7.50654 0.435547 7.61022C0.435547 7.7139 0.455996 7.81657 0.495723 7.91234C0.53545 8.00811 0.593675 8.0951 0.667065 8.16834L7.24582 14.7471C7.63373 15.135 8.25915 15.135 8.64707 14.7471C9.03498 14.3592 9.03498 13.7338 8.64707 13.3458L2.9154 7.60626L8.65498 1.86668C9.03498 1.48668 9.03498 0.853344 8.64707 0.473344Z"
                    fill="#1E232C"
                    stroke="#1E232C"
                    stroke-width="0.2"
                  />
                </svg>
              </Link>
              <h4 className="mb-0 py-3 fw-bold themeBlue text-capitalize">
                Refund Transaction Information
              </h4>
            </div>
          </Col>

          <Col lg="12" className="my-2">
            <div
              className="formWrpper px-lg-5 p-md-4 p-3 rounded"
              style={{ background: "#EEEEEE" }}
            >
              {isLoading && (
                <div className="text-center">
                  <div className="spinner-border text-dark" role="status">
                    <span className="sr-only">Loading...</span>
                  </div>
                </div>
              )}
              {!isLoading && User?.data && (
                <Row className="justify-content-between">
                  {/* <Col lg="12" className="my-2">
                  <div className="text-end">
                    <div className="d-inline-flex align-items-center gap-10">
                      <label
                        htmlFor=""
                        className="form-label m-0 text-muted fw-sbold"
                      >
                        Status
                      </label>
                      <Form.Check // prettier-ignore
                        type="switch"
                        id="custom-switch"
                        checked
                      />
                    </div>
                  </div>
                </Col> */}

                  <Col lg="12" className="my-2">
                    {/* <div
                      className="imgWrp text-center mx-auto"
                      style={{ maxWidth: "max-content" }}
                    >
                      <img
                        src={User?.data?.transactionId?.userId?.profileImage || i1}
                        style={{ height: 140, width: 140 }}
                        alt=""
                        className="img-fluid rounded-circle object-fit-cover"
                      />
                    </div> */}
                  </Col>
                  {/* <Col md={6} className="my-2">
                    <ul className="list-unstyled ps-0 mb-0 notLastBorder pe-lg-3">
                      <li className="py-3 d-flex align-items-center gap-10">
                        <p className="m-0 themeBlue fw-sbold w-25">
                          User Name:
                        </p>
                        <h6 className="m-0 text-muted fw-bold w-50">
                          {User?.data?.name}
                        </h6>
                      </li>
                      <li className="py-3 d-flex align-items-center gap-10">
                        <p className="m-0 themeBlue fw-sbold w-25">Email:</p>
                        <h6 className="m-0 text-muted fw-bold w-50">
                          {User?.data?.email}
                        </h6>
                      </li>
                      <li className="py-3 d-flex align-items-center gap-10">
                        <p className="m-0 themeBlue fw-sbold w-25">Address:</p>
                        <h6 className="m-0 text-muted fw-bold w-50">
                          3891 Ranchview Dr. Richardson, California 62639
                        </h6>
                      </li>
                      <li className="py-3 d-flex align-items-center gap-10">
                        <p className="m-0 themeBlue fw-sbold w-25">
                          Phone Number:
                        </p>
                        <p className="m-0 text-muted fw-bold w-50">
                          {User?.data?.mobileNumber}
                        </p>
                      </li>
                    </ul>
                  </Col> */}

                  {/* <Col md={6} className="my-2">
                    <ul className="list-unstyled mb-0 notLastBorder ps-lg-3">
                      <li className="py-3 d-flex align-items-center gap-10">
                        <p className="m-0 themeBlue fw-sbold w-25">
                          Created at:
                        </p>
                        <h6 className="m-0 text-muted fw-bold w-50">
                          {moment(User?.data.createdAt).format("DD/MM/YYYY")}
                        </h6>
                      </li>
                      <li className="py-3 d-flex align-items-center gap-10">
                        <p className="m-0 themeBlue fw-sbold w-25">Status:</p>
                        <h6 className="m-0 text-muted fw-bold w-50 text-capitalize">
                          {User?.data?.status}
                        </h6>
                      </li>
                    </ul>
                  </Col> */}

                  <Col md="6" className="my-2">
                    <div className="cardCstm bg-light rounded-3 p-2 px-3">
                      <ul className="list-unstyled pl-0 mb-0">
                        <li className="py-2 border-bottom">
                          <div className="py-1">
                            <h6 className="m-0 fw-sbold text-base pb-1">
                              User Name
                            </h6>
                            {User?.data?.transactionId?.userId?.name}
                            <p className="m-0 text-gray-500">{ }</p>
                          </div>
                        </li>
                        <li className="py-2 border-bottom">
                          <div className="py-1">
                            <h6 className="m-0 fw-sbold text-base pb-1">
                              Email
                            </h6>
                            <p className="m-0 text-gray-500">
                              {User?.data?.transactionId?.userId?.email}
                            </p>
                          </div>
                        </li>
                      </ul>
                    </div>

                  </Col>


                  <Col md="6" className="my-2">
                    <div className="cardCstm bg-light rounded-3 p-2 px-3">
                      <ul className="list-unstyled pl-0 mb-0">
                        <li className="py-2 border-bottom">
                          <div className="py-1">
                            <h6 className="m-0 fw-sbold text-base pb-1">
                              Created at
                            </h6>
                            {moment(User?.data.createdAt).format("DD/MM/YYYY")}
                            <p className="m-0 text-gray-500">{ }</p>
                          </div>
                        </li>
                        <li className="py-2 border-bottom">
                          <div className="py-1">
                            <h6 className="m-0 fw-sbold text-base pb-1">
                              Status
                            </h6>
                            <p className="m-0 text-gray-500">
                              {User?.data?.status}
                            </p>
                          </div>
                        </li>
                        <li className="py-2 border-bottom">
                          <div className="py-1">
                            <h6 className="m-0 fw-sbold text-base pb-1">
                              Cancel Reason
                            </h6>
                            <p className="m-0 text-gray-500">
                              {User?.data?.transactionId?.orderId?.cancelReason || "N/A"}
                            </p>
                          </div>
                        </li>
                      </ul>
                    </div>

                  </Col>



                  <Col md="6" className="my-2">
                    <div className="cardCstm bg-light rounded-3 p-2 px-3">
                      <ul className="list-unstyled pl-0 mb-0">
                        <li className="py-2 border-bottom">
                          <div className="py-1">
                            <h6 className="m-0 fw-sbold text-base pb-1">
                              Phone Number
                            </h6>
                            {User?.data?.transactionId?.orderId?.deliveryAddress?.phoneNumber}
                            <p className="m-0 text-gray-500">{ }</p>
                          </div>
                        </li>
                        <li className="py-2 border-bottom">
                          <div className="py-1">
                            <h6 className="m-0 fw-sbold text-base pb-1">
                              Delivery Address
                            </h6>
                            <p className="m-0 text-gray-500">
                              {User?.data?.transactionId?.orderId?.deliveryAddress?.addressLine1}
                            </p>
                          </div>
                        </li>
                      </ul>
                    </div>

                  </Col>



                  <Col md="6" className="my-2">
                    <div className="cardCstm bg-light rounded-3 p-2 px-3">
                      <div className="top pb-2">
                        <h6 className="m-0 fw-sbold text-base pb-1">
                          Order Summary
                        </h6>
                      </div>
                      <ul className="list-unstyled pl-0 mb-0">
                        <li className="py-2 border-bottom">
                          <ul className="list-unstyled pl-0 mb-0">

                            <li className="py-2 d-flex align-items-center justify-content-between">
                              <p className="m-0 fw-normal text-dark text-base">
                                Meal Plan Price <br /> (incl. vat)
                              </p>
                              <p className="m-0 fw-normal text-dark text-base">
                                {priceCurrency(User?.data?.transactionId?.orderId?.originalSubTotal)}
                              </p>
                            </li>
                             <li className="py-2 d-flex align-items-center justify-content-between">
                                                            <p className="m-0 fw-normal text-dark text-base">
                                                              Online Order Price (incl.vat)
                                                            </p>
                                                            <p className="m-0 fw-normal text-dark text-base">
                                                              {priceCurrency(
                                                               User?.data?.transactionId?.orderId?.totalStorePrice||"0"
                                                              )}
                                                            </p>
                                                          </li>
                            {User?.data?.transactionId?.orderId?.isLongTermApplied && (
                              <>
                                <li className="py-2 border-bottom">
                                  <div className="d-flex align-items-center justify-content-between py-2">
                                    <div className="left d-flex align-items-center gap-2">
                                      <span className="icn">
                                        <svg
                                          width="14"
                                          height="14"
                                          viewBox="0 0 14 14"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <g clip-path="url(#clip0_1_22289)">
                                            <rect
                                              width="14"
                                              height="14"
                                              rx="7"
                                              fill="#32936F"
                                              fill-opacity="0.24"
                                            ></rect>
                                            <path
                                              d="M9.86256 5.11575C9.82287 5.07908 9.77565 5.04996 9.72362 5.0301C9.6716 5.01023 9.6158 5 9.55944 5C9.50308 5 9.44728 5.01023 9.39525 5.0301C9.34323 5.04996 9.29601 5.07908 9.25632 5.11575L6.0757 8.03506L4.73941 6.80629C4.6982 6.76981 4.64956 6.74112 4.59625 6.72186C4.54295 6.70261 4.48603 6.69316 4.42874 6.69407C4.37146 6.69498 4.31493 6.70622 4.26238 6.72716C4.20983 6.74809 4.1623 6.7783 4.1225 6.81608C4.08269 6.85385 4.05139 6.89844 4.03038 6.9473C4.00938 6.99615 3.99907 7.04833 4.00007 7.10084C4.00106 7.15335 4.01332 7.20516 4.03616 7.25332C4.059 7.30149 4.09196 7.34506 4.13317 7.38155L5.77258 8.88425C5.81227 8.92092 5.85948 8.95004 5.91151 8.9699C5.96353 8.98977 6.01934 9 6.0757 9C6.13206 9 6.18786 8.98977 6.23988 8.9699C6.29191 8.95004 6.33913 8.92092 6.37882 8.88425L9.86256 5.69101C9.90589 5.65436 9.94048 5.60989 9.96413 5.56038C9.98779 5.51088 10 5.45742 10 5.40338C10 5.34934 9.98779 5.29588 9.96413 5.24638C9.94048 5.19687 9.90589 5.1524 9.86256 5.11575Z"
                                              fill="#32936F"
                                            ></path>
                                          </g>
                                          <defs>
                                            <clipPath id="clip0_1_22289">
                                              <rect
                                                width="14"
                                                height="14"
                                                rx="7"
                                                fill="white"
                                              ></rect>
                                            </clipPath>
                                          </defs>
                                        </svg>
                                      </span>
                                      <p className="m-0 text-dark fw-normal">
                                        {
                                          User?.data?.transactionId?.orderId?.planDurationDetails
                                            ?.label
                                        }{" "}
                                        <span className="text-muted">applied</span>
                                      </p>
                                    </div>
                                    <div className="right">
                                      <p className="m-0 text-muted small fw-light">
                                        -
                                        {priceCurrency(
                                          User?.data?.transactionId?.orderId?.longTermDiscountValue
                                        )}
                                        {/* calculate percentage and show  */}(
                                        {`${User?.data?.transactionId?.orderId?.planDurationDetails?.discount}%`}
                                        )
                                      </p>
                                    </div>
                                  </div>
                                </li>
                                <li className="py-2 d-flex align-items-center justify-content-between">
                                  <p className="m-0 fw-normal text-dark text-base">
                                    Discounted Price
                                  </p>
                                  <p className="m-0 fw-normal text-dark text-base">
                                    {priceCurrency(
                                      User?.data?.transactionId?.orderId?.longTermDiscount
                                    )}
                                  </p>
                                </li>
                              </>
                            )}

                            {User?.data?.transactionId?.orderId?.isPromo && (
                              <>
                                <li className="py-2 border-bottom">
                                  <div className="d-flex align-items-center justify-content-between py-2">
                                    <div className="left d-flex align-items-center gap-2">
                                      <span className="icn">
                                        <svg
                                          width="14"
                                          height="14"
                                          viewBox="0 0 14 14"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <g clip-path="url(#clip0_1_22289)">
                                            <rect
                                              width="14"
                                              height="14"
                                              rx="7"
                                              fill="#32936F"
                                              fill-opacity="0.24"
                                            ></rect>
                                            <path
                                              d="M9.86256 5.11575C9.82287 5.07908 9.77565 5.04996 9.72362 5.0301C9.6716 5.01023 9.6158 5 9.55944 5C9.50308 5 9.44728 5.01023 9.39525 5.0301C9.34323 5.04996 9.29601 5.07908 9.25632 5.11575L6.0757 8.03506L4.73941 6.80629C4.6982 6.76981 4.64956 6.74112 4.59625 6.72186C4.54295 6.70261 4.48603 6.69316 4.42874 6.69407C4.37146 6.69498 4.31493 6.70622 4.26238 6.72716C4.20983 6.74809 4.1623 6.7783 4.1225 6.81608C4.08269 6.85385 4.05139 6.89844 4.03038 6.9473C4.00938 6.99615 3.99907 7.04833 4.00007 7.10084C4.00106 7.15335 4.01332 7.20516 4.03616 7.25332C4.059 7.30149 4.09196 7.34506 4.13317 7.38155L5.77258 8.88425C5.81227 8.92092 5.85948 8.95004 5.91151 8.9699C5.96353 8.98977 6.01934 9 6.0757 9C6.13206 9 6.18786 8.98977 6.23988 8.9699C6.29191 8.95004 6.33913 8.92092 6.37882 8.88425L9.86256 5.69101C9.90589 5.65436 9.94048 5.60989 9.96413 5.56038C9.98779 5.51088 10 5.45742 10 5.40338C10 5.34934 9.98779 5.29588 9.96413 5.24638C9.94048 5.19687 9.90589 5.1524 9.86256 5.11575Z"
                                              fill="#32936F"
                                            ></path>
                                          </g>
                                          <defs>
                                            <clipPath id="clip0_1_22289">
                                              <rect
                                                width="14"
                                                height="14"
                                                rx="7"
                                                fill="white"
                                              ></rect>
                                            </clipPath>
                                          </defs>
                                        </svg>
                                      </span>
                                      <p className="m-0 text-dark fw-normal">
                                        {User?.data?.transactionId?.orderId?.couponDetail?.code}{" "}
                                        <span className="text-muted">applied</span>
                                      </p>
                                    </div>
                                    <div className="right">
                                      <p className="m-0 text-muted small fw-light">
                                        -
                                        {priceCurrency(
                                          User?.data?.transactionId?.orderId?.discountPrice
                                        )}{" "}
                                        (
                                        {/* {User?.data?.transactionId?.orderId?.couponDetail
                                          ?.discountType === "Percent"
                                          ? `${User?.data?.transactionId?.orderId?.couponDetail?.discountValue}%`
                                          : `AED ${User?.data?.transactionId?.orderId?.couponDetail?.discountValue}`} */}


                                        {User?.data?.transactionId?.orderId?.couponDetail && (
                                          `${User?.data?.transactionId?.orderId?.couponDetail.promoCodeType === "userReferral" &&
                                          User?.data?.transactionId?.userId?._id === User?.data?.transactionId?.orderId?.couponDetail?.addedBy
                                            ? User.data.transactionId.orderId.couponDetail.referralDiscountForReferrer
                                            : User.data.transactionId.orderId.couponDetail.discountValue
                                          } ${User.data.transactionId.orderId.couponDetail.discountType === "Percent" ? "%" : "AED"}`
                                        )}


                                        )
                                      </p>
                                    </div>
                                  </div>
                                </li>
                                <li className="py-2 d-flex align-items-center justify-content-between">
                                  <p className="m-0 fw-normal text-dark text-base">
                                    Sub total
                                  </p>
                                  <p className="m-0 fw-normal text-dark text-base">
                                    {priceCurrency(
                                      User?.data?.transactionId?.orderId?.subTotalAfterPromo
                                    )}
                                  </p>
                                </li>
                                
                              </>
                            )}

                            {User?.data?.transactionId?.orderId?.isAdvanceMacro && (
                              <li className="py-2 d-flex align-items-center justify-content-between">
                                <p className="m-0 fw-normal text-dark text-base">
                                  Advanced Macro Fee
                                </p>
                                <p className="m-0 fw-normal text-dark text-base">
                                  {priceCurrency(
                                    User?.data?.transactionId?.orderId?.advanceMacroFees
                                  )}
                                </p>
                              </li>
                            )}

                            {/* <li className="py-2 d-flex align-items-center justify-content-between">
                              <p className="m-0 fw-normal text-dark text-base">
                                Advance Macro Fee
                              </p>
                              <p className="m-0 fw-normal text-dark text-base">
                               
                                {priceCurrency(User?.data?.transactionId?.orderId?.advanceMacroFees)}
                              </p>
                            </li> */}

                            <li className="py-2 d-flex align-items-center justify-content-between">
                              <p className="m-0 fw-normal text-dark text-base">
                                Delivery Fees
                              </p>
                              <p className="m-0 fw-normal text-dark text-base">
                                {/* AED {User?.data?.transactionId?.orderId?.deliveryFees} */}
                                {priceCurrency(User?.data?.transactionId?.orderId?.deliveryFees)}
                              </p>
                            </li>

                            <li className="py-2 d-flex align-items-center justify-content-between">
                              <p className="m-0 fw-normal text-dark text-base">
                                Cooler Bag Deposit
                              </p>
                              <p className="m-0 fw-normal text-dark text-base">
                                {/* AED {User?.data?.transactionId?.orderId?.boxPrice} */}
                                {priceCurrency(User?.data?.transactionId?.orderId?.boxPrice)}
                              </p>
                            </li>

                            {/* <li className="py-2 d-flex align-items-center justify-content-between">
                              <p className="m-0 fw-normal text-dark text-base">
                                Discount Price
                              </p>
                              <p className="m-0 fw-normal text-dark text-base">
                                
                                {priceCurrency(User?.data?.transactionId?.orderId?.discountPrice)}
                              </p>
                            </li> */}
                          </ul>
                        </li>
                        <li className="py-2 border-bottom">
                          <div
                            className=" py-2 px-3 d-flex align-items-center justify-content-between"
                            style={{ background: "rgb(241, 241, 234)" }}
                          >
                            <p className="m-0 fw-sbold text-dark">Total Payment</p>
                            <p className="m-0 fw-sbold text-dark">
                              {" "}
                              {priceCurrency(User?.data?.transactionId?.orderId?.payAmount)}
                              {/* AED  {User?.data?.transactionId?.orderId?.payAmount} */}
                            </p>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </Col>


                  {/* <Col md="6" className="my-2">
                    <div className="cardCstm bg-light rounded-3 p-2 px-3">
                      <div className="top pb-2">
                        <h6 className="m-0 fw-sbold text-base pb-1">
                          Card Details
                        </h6>
                      </div>
                      <ul className="list-unstyled pl-0 mb-0">
                        <li className="py-2 border-bottom">
                          <ul className="list-unstyled pl-0 mb-0">
                            <li className="py-2 d-flex align-items-center justify-content-between">
                              <p className="m-0 fw-normal text-dark text-base">
                                Amount
                              </p>
                              <p className="m-0 fw-normal text-dark text-base">
                                AED {User?.data?.transactionId?.amount}

                              </p>
                            </li>
                            <li className="py-2 d-flex align-items-center justify-content-between">
                              <p className="m-0 fw-normal text-dark text-base">
                                Created At
                              </p>
                              <p className="m-0 fw-normal text-dark text-base">
                                {moment(User?.data?.transactionId?.createdAt).format("DD/MM/YYYY")}

                              </p>
                            </li>
                            <li className="py-2 d-flex align-items-center justify-content-between">
                              <p className="m-0 fw-normal text-dark text-base">
                                Card Type
                              </p>
                              <p className="m-0 fw-normal text-dark text-base">
                                {User?.data?.transactionId?.cardDetail?.type}

                              </p>
                            </li>
                            <li className="py-2 d-flex align-items-center justify-content-between">
                              <p className="m-0 fw-normal text-dark text-base">
                                First Six Digit
                              </p>
                              <p className="m-0 fw-normal text-dark text-base">
                               
                                {User?.data?.transactionId?.cardDetail?.first6}
                              </p>
                            </li>

                            <li className="py-2 d-flex align-items-center justify-content-between">
                              <p className="m-0 fw-normal text-dark text-base">
                                Last Four Digit
                              </p>
                              <p className="m-0 fw-normal text-dark text-base">
                               
                                {User?.data?.transactionId?.cardDetail?.last4}
                              </p>
                            </li>

                            <li className="py-2 d-flex align-items-center justify-content-between">
                              <p className="m-0 fw-normal text-dark text-base">
                                Expiry Month
                              </p>
                              <p className="m-0 fw-normal text-dark text-base">
                               
                                {User?.data?.transactionId?.cardDetail?.expiry?.month}
                              </p>
                            </li>

                            <li className="py-2 d-flex align-items-center justify-content-between">
                              <p className="m-0 fw-normal text-dark text-base">
                                Expiry Year
                              </p>
                              <p className="m-0 fw-normal text-dark text-base">
                               
                                {User?.data?.transactionId?.cardDetail?.expiry?.year}
                              </p>
                            </li>


                          </ul>
                        </li>

                      </ul>
                    </div>
                  </Col> */}

                </Row>

              )}



            </div>
          </Col>







        </Row>
      </Container>
    </section>
  );
};

export default RefundDetail;
